import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { Container } from "@pixi/react";

export const OverlaySymbol = forwardRef(({ index, y }, ref) => {
  const containerRef = useRef(null);

  // Expose container ref directly
  useImperativeHandle(ref, () => containerRef.current);

  return (
    <Container  
      ref={containerRef}
      y={y}
      x={0}
      zIndex={6}
      sortableChildren
      name={`spine_overlay_symbol_${index}`}
    />
  );
});

export default OverlaySymbol;
